/* TODO: Resolve type inference and polymorphic type issues in WDSButton. Remove these disables once resolved. */

/* eslint-disable @typescript-eslint/no-explicit-any */

import { Button as WDSButton, ButtonProps as WDSButtonProps } from "@datamole/wds-component-button";
import { forwardRefPolymorphic } from "@datamole/wds-std";
import { clsx } from "clsx";
import { type ElementType, type ForwardedRef } from "react";

import styles from "@/components/ui/button/button.module.css";

type BaseVariant = WDSButtonProps["variant"];
type CustomVariant = "secondary"; // Add more custom variants as needed
type Variant = BaseVariant | CustomVariant;

type Props<TAs extends ElementType = "button"> = Omit<WDSButtonProps<TAs>, "variant"> & {
    variant?: Variant;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    startIconClassName?: string;
    endIconClassName?: string;
};

const Button = <TAs extends ElementType = "button">(props: Props<TAs>, ref: ForwardedRef<unknown>) => {
    const { children, startIcon, endIcon, startIconClassName, endIconClassName, variant, className, ...otherProps } =
        props;

    const customVariants = new Set<CustomVariant>(["secondary"]);
    const isCustom = variant && customVariants.has(variant as CustomVariant);

    return (
        <WDSButton
            {...otherProps}
            ref={ref as any}
            variant={isCustom ? undefined : (variant as BaseVariant)}
            className={clsx(className, isCustom && styles[variant as CustomVariant])}
        >
            {startIcon && <WDSButton.Icon className={startIconClassName}>{startIcon}</WDSButton.Icon>}
            {children && <WDSButton.Content>{children}</WDSButton.Content>}
            {endIcon && <WDSButton.Icon className={endIconClassName}>{endIcon}</WDSButton.Icon>}
        </WDSButton>
    );
};
const ButtonWithRefForwarded = forwardRefPolymorphic(Button);

Button.displayName = "Button";

export { ButtonWithRefForwarded as Button };
export type { Props as ButtonProps };
